import { decreaseContrast, interpolate } from '../util';
import { graphDataStyle, graphWallFill } from './';
export const graphThreeColorRamp = {
  rampDefault(theme, parameters) {
    const style1 = graphDataStyle.style1(theme, parameters);
    const style2 = graphDataStyle.style2(theme, parameters);
    return {
      fillGradientStartColor: style1.color,
      fillGradientNeutralColor: decreaseContrast(interpolate(style1.color, style2.color), graphWallFill(theme, parameters).fillColor, 61),
      fillGradientEndColor: style2.color
    };
  },
  ramp1(theme, parameters) {
    const style1 = graphDataStyle.style1(theme, parameters);
    const style2 = graphDataStyle.style2(theme, parameters);
    return {
      fillGradientStartColor: style1.color,
      fillGradientNeutralColor: decreaseContrast(interpolate(style1.color, style2.color), graphWallFill(theme, parameters).fillColor, 61),
      fillGradientEndColor: style2.color
    };
  },
  ramp2(theme, parameters) {
    const style3 = graphDataStyle.style3(theme, parameters);
    const style4 = graphDataStyle.style4(theme, parameters);
    return {
      fillGradientStartColor: style3.color,
      fillGradientNeutralColor: decreaseContrast(interpolate(style3.color, style4.color), graphWallFill(theme, parameters).fillColor, 61),
      fillGradientEndColor: style4.color
    };
  },
  ramp3(theme, parameters) {
    const style5 = graphDataStyle.style5(theme, parameters);
    const style6 = graphDataStyle.style6(theme, parameters);
    return {
      fillGradientStartColor: style5.color,
      fillGradientNeutralColor: decreaseContrast(interpolate(style5.color, style6.color), graphWallFill(theme, parameters).fillColor, 61),
      fillGradientEndColor: style6.color
    };
  },
  ramp4(theme, parameters) {
    const style7 = graphDataStyle.style7(theme, parameters);
    const style8 = graphDataStyle.style8(theme, parameters);
    return {
      fillGradientStartColor: style7.color,
      fillGradientNeutralColor: decreaseContrast(interpolate(style7.color, style8.color), graphWallFill(theme, parameters).fillColor, 61),
      fillGradientEndColor: style8.color
    };
  }
};
//# sourceMappingURL=graphThreeColorRamp.js.map